import React from 'react';

function SearchResults({ results }) {
  // Ensure results is an array and contains valid objects
  if (!Array.isArray(results)) {
    console.error('SearchResults received non-array results:', results);
    return <div className="error">Invalid search results format</div>;
  }

  return (
    <div className="search-results">
      {results.map((result, index) => {
        // Validate each result object
        if (!result || typeof result !== 'object') {
          console.error('Invalid result object at index', index, result);
          return null;
        }
        
        return (
          <div key={index} className="search-result-card">
            <div className="result-header">
              <h3 className="project-name">{result.project_name || 'Unknown Project'}</h3>
              <div className="similarity-score">
                <span className="score-label">Relevance:</span>
                <span className={`score-value ${getScoreClass(result.similarity_score || 0)}`}>
                  {Math.round((result.similarity_score || 0) * 100)}%
                </span>
              </div>
            </div>
            
            <div className="result-content">
              <div className="result-section">
                <h4>📍 Location</h4>
                <p>{result.location || 'Location not specified'}</p>
              </div>
              
              <div className="result-section">
                <h4>📝 Summary</h4>
                <p>{result.summary || 'No summary available'}</p>
              </div>
              
              <div className="result-section">
                <h4>🏢 Facilities</h4>
                <p>{result.facilities || 'Facilities information not available'}</p>
              </div>
              
              <div className="result-section">
                <h4>💰 Payment Plans</h4>
                <p>{result.payment_plans || 'Payment plan information not available'}</p>
              </div>
              
              <div className="result-section">
                <h4>📐 Average Area</h4>
                <p>{result.average_area || 'Area information not available'}</p>
              </div>
              
              <div className="result-footer">
                <span className="source-file">📄 Source: {result.source_file || 'Unknown source'}</span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

function getScoreClass(score) {
  if (score >= 0.8) return 'excellent';
  if (score >= 0.6) return 'good';
  if (score >= 0.4) return 'fair';
  return 'low';
}

export default SearchResults;
